import { ConsentKind } from './enums'

// ============================================================================
// Preferences
// ============================================================================

export const PREFERENCE_KEYS = {
  THEME: 'theme',
  LANGUAGE: 'language',
  TIMEZONE: 'timezone',
  NOTIFICATIONS_ENABLED: 'notifications_enabled',
  SIDEBAR_COLLAPSED: 'sidebar_collapsed',
  DASHBOARD_LAYOUT: 'dashboard_layout',
} as const

export type PreferenceKey =
  (typeof PREFERENCE_KEYS)[keyof typeof PREFERENCE_KEYS]

// ============================================================================
// Labels & Descriptions
// ============================================================================

export const CONSENT_LABELS: Record<
  ConsentKind,
  { title: string; description: string } | undefined
> = {
  [ConsentKind.TERMS]: {
    title: 'Conditions générales',
    description: "J'accepte les conditions générales d'utilisation du service.",
  },
  [ConsentKind.TERMS_OF_SERVICE]: {
    title: 'Conditions générales',
    description: "J'accepte les conditions générales d'utilisation du service.",
  },
  [ConsentKind.PRIVACY]: {
    title: 'Politique de confidentialité',
    description:
      "J'accepte la politique de confidentialité et le traitement de mes données personnelles.",
  },
  [ConsentKind.PRIVACY_POLICY]: {
    title: 'Politique de confidentialité',
    description:
      "J'accepte la politique de confidentialité et le traitement de mes données personnelles.",
  },
  [ConsentKind.MARKETING]: {
    title: 'Communications marketing',
    description:
      "J'accepte de recevoir des communications marketing et promotionnelles.",
  },
  [ConsentKind.ANALYTICS]: {
    title: 'Données analytiques',
    description:
      "J'accepte la collecte de données analytiques pour améliorer le service.",
  },
  [ConsentKind.COOKIES]: {
    title: 'Cookies',
    description:
      "J'accepte l'utilisation de cookies pour personnaliser mon expérience.",
  },
  // Default fallbacks for other kinds
  [ConsentKind.DATA_SHARING]: undefined,
  [ConsentKind.DATA_PROCESSING]: undefined,
  [ConsentKind.AUP]: undefined,
  [ConsentKind.CODE_OF_CONDUCT]: undefined,
  [ConsentKind.PARENTAL_CONSENT]: undefined,
  [ConsentKind.MEDIA_RELEASE]: undefined,
}
